import React from 'react'
import Isvg from 'react-inlinesvg'
import './Cost.scss'

const CostCard = ({icon, title, text}) => {
    const helperClass = title.toLowerCase()
    return (
        <div className={`cost-card -${helperClass}`}>
            <div className="icon-container">
                <Isvg src={icon} />
            </div>
            <h5>{title}</h5>
            <p>{text}</p>
        </div>
    );
};

export default CostCard


// WEBPACK FOOTER //
// ./src/components/Card/Cost.js